module.exports = __webpack_public_path__ + "static/media/match.22657acf.png";